import { TOKEN } from "../actions/tokenAction";

const default_token_value = {
    value: ''
}


const tokenReducer = (state = default_token_value, action) => {
    switch (action.type) {
        case TOKEN: {
            return {
                token: action.info
            }
        }
        default: return state;
    }
}

export default tokenReducer